export default "__VITE_ASSET__4a4e04cc__"